module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-gesuch-circle-6bfa4d35e270de99e64df44277c4f6e2.svg";